import styled from "styled-components";

export const REDDIT_IMAGE_SIZE_SPEC = {
  // 1.91:1 = 459:240.3
  web: {
    width: 489, // plus 30px padding
    pictureWidth: 459,
    minHeight: 240.3,
    maxHeight: 459
  },
  mobile: {
    width: 489,
    pictureWidth: 459,
    minHeight: 240.3,
    maxHeight: 459
  }
};

export const PostEditorWrapper = styled.div`
  display: flex;
  padding: 10px 15px;
  background: #fff;
  border: 1px solid #e8e8eb;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
  ${(props) =>
    props.mobile
      ? `
  width: ${REDDIT_IMAGE_SIZE_SPEC.mobile.width}px;
`
      : `
  width: ${REDDIT_IMAGE_SIZE_SPEC.web.width}px;
`}
`;

export const BodyWrapper = styled.div`
  width: 100%;
`;

export const EditorWrapper = styled.div`
  width: 100%;
  padding-bottom: 5px;
`;

export const teaserTextStyle = {
  fontSize: "14px"
};

export const displayLinkStyle = {
  color: "#24a0ed",
  cursor: "pointer"
};

//ADDED

export const Header = styled.div`
  display: flex;
  padding-bottom: 10px;
`;
export const Avatar = styled.img`
  border-radius: 4px;
  width: 40px;
  height: 40px;
`;
export const UserInfo = styled.div`
  flex-grow: 1;
  padding-left: 8px;
  text-align: left;
`;

export const Promoted = styled.span`
  display: inline-block;
  width: 100%;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  font-size: 13px;
  color: #24a0ed;
  padding: 3px 6px;
`;

export const Sponsored = styled.span`
  font-family: Helvetica Neue;
  font-weight: 400;
  font-weight: 400;
  width: 100px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.5);
  padding-left: 6px;
`;

export const Bar = styled.img`
  width: 100%;
  margin-top: 10px;
`;
export const BarCTA = styled.div`
  width: 100%;
  background: #f6f7f8;
  padding: 0px 10px;
  height: 48px;
  line-height: 40px;
  margin-top: 10px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const BarCTABtn = styled.div`
  padding: 0px 10px;
  height: 30px;
  border: 1px solid #24a0ed;
  float: right;
  border-radius: 3px;
  text-align: center;
  color: #24a0ed;
  font-weight: 500;
  font-size: 10px;
  cursor: pointer;
  line-height: 27px;
`;
